import styled from '@emotion/styled';
// --- external imports -----

import checkmarkProjection from '../../assets/images/baseAssets/btn-ok-53.png';
import cancelProjection from '../../assets/images/baseAssets/btn-cancel-53.png';
// --- internal imports -----

import Asset from './BaseAssets';
// --- local imports -----

const CheckmarkBtn = styled(Asset.Button.withProps({
	projection: {
		src: checkmarkProjection.src,
		width: 77,
		height: 77
	}
}))`
	border-radius: 50%;
`;

const CancelBtn = styled(Asset.Button.withProps({
	projection: {
		src: cancelProjection.src,
		width: 77,
		height: 77
	}
}))`
	border-radius: 50%;
`;

const Label = styled(Asset.Text)`
	font-family: Wonderfull;
	color: #fdeea9;
	line-height: 1.6;
`;

export {
	Label,
	CheckmarkBtn,
	CancelBtn
};
